import { inject, Injectable } from '@angular/core';
import { AdminApiService } from '@services/admin/admin-api.service';
import { ModalWindowService } from '@services/admin/modal-window.service';
import { DataService } from '@services/admin/data.service';
import { ActionModel } from '@models/admin/action.model';

@Injectable()
export class ActionHandlerService {
  private readonly adminApiService = inject(AdminApiService);
  private readonly modalWindowService = inject(ModalWindowService);
  private readonly dataService = inject(DataService);

  executeAction(action: ActionModel, data: any, afterActionCallback?: () => void) {
    let requestData = {};

    if (data) {
      for (let key in action.dynamicParams) {
        requestData[key] = data[action.dynamicParams[key]];
      }
      for (let key in action.params) {
        requestData[key] = action.params[key];
      }
    }

    requestData = Object.keys(requestData).length ? requestData : action.params;

    if (action.form) {
      this.handleFormAction(action, requestData, afterActionCallback);
    } else if (action.method?.includes('file')) {
      this.dataService.downloadFile(action.method, requestData);
    } else {
      this.dataService.sendData(action.method, requestData)
        .subscribe(() => {
          if (afterActionCallback) {
            afterActionCallback();
          }
        });
    }
  }

  private handleFormAction(action: ActionModel, data: any, afterActionCallback?: () => void) {
    this.adminApiService.getModalFormSchema(action.form, data);
    this.modalWindowService.setFormMethod(action);
    if (afterActionCallback) {
      this.modalWindowService.methodAfterForm = afterActionCallback;
    }
  }
}
